module.exports = __webpack_public_path__ + "src/assets/img/kinoplan.203c45e9.jpg";